/** Per-browser preferences, stored in localStorage (lib/local-store.ts). */
import { readLocal, writeLocal } from "@/lib/local-store";

export const COUNTDOWN_KEY = "qpp_countdown";

/** Whether this viewer wants the 3-2-1 countdown (when the room has it on). Default: yes. */
export function countdownEnabled(value: string | null = readLocal(COUNTDOWN_KEY)): boolean {
  return value !== "off";
}

export function setCountdownEnabled(enabled: boolean): void {
  writeLocal(COUNTDOWN_KEY, enabled ? "on" : "off");
}
